import { Component, OnInit } from '@angular/core';
import { bool } from 'aws-sdk/clients/signer';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { MatDialog } from '@angular/material/dialog';
import { MessageModalComponent } from './message-modal/message-modal.component';
import { getgroups } from 'process';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Guid } from 'guid-typescript';
import { TimeService } from 'src/app/services/time/time.service';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-preset-messages',
  templateUrl: './preset-messages.component.html',
  styleUrls: ['./preset-messages.component.css']
})
export class PresetMessagesComponent implements OnInit {

  cannedMessageData: any[] = [];
  filteredCannedMessageData: any[] = [];
  LOBs: any [] = [];
  LOBFilter: string = "";
  groups: any[] = [];
  filteredGroups: any[] = [];
  currentUser: string = this.auth.currentUser;
  editable: bool = true;
  editMessage: string = ""; 
  blueprint = { message:'', group: null , id: ""};

  cannedMessageForm = this.formBuilder.group({
    message: new FormControl('', [Validators.required]),
    group: new FormControl('', [Validators.required])
  });
  createdDate: any;
  creating: boolean = false;
  editing: boolean = false;

  constructor(
    private formBuilder:FormBuilder, 
    private telecomService:TelecomService, 
    private snackbar: MatSnackBar, 
    public dialog: MatDialog, 
    private timeService: TimeService, 
    private auth:AuthService
  ) { }

  ngOnInit(): void {
    this.getLOBs();
    this.getGroups();
    this.getPresetMessages();
  }

  formatGroupFunction = (group) => {
    if(this.groups.length>0){
      return this.groups.find((groupRow) => {return groupRow.groupId == group}).groupName;
    }
    return group
  }

  formatMessageLength = (message:string) => {
    let maxlength = 30
    if(message.length >= maxlength){
      return message.slice(0, maxlength-3) + "..."
    }
    return message
  }

  getLOBs(){
    let params = {
      FunctionName: environment.getLOBsLambdaName,
      Payload: JSON.stringify({
        operation: "get"
      })
    };
    this.telecomService.callLambda(params, "An error occurred getting LOB data").then((response: any) => {
      if(response.statusCode == 200){
        console.log('response: ', response);
        //get data from response and syncronize local copy
        this.LOBs = response.body.LOBs.Item.data;
        console.log(`data updated: ${JSON.stringify(this.LOBs)}`);
      }else{
        console.error(response); 
        this.snackbar.open(`Error: ${JSON.stringify(response.Error)}`, "Ok", {verticalPosition: 'bottom'});
      }
    });
  }

  getGroups(){
    let params = {
      FunctionName: environment.GroupsLambdaName,
      Payload: JSON.stringify({
        operation: "get"
      })
    };
    this.telecomService.callLambda(params, "An error occurred getting group data").then((response: any) => {
      if(response.statusCode == 200){
        console.log(`response: ${response}`);
        //get data from response and syncronize local copy
        this.groups = response.body.Group.Item.data;
        console.log(`data updated: ${JSON.stringify(this.groups)}`);
        this.applyFilter(this.LOBFilter);
      }else{
        console.error(response); 
        this.snackbar.open(`Error: ${JSON.stringify(response.Error)}`, "Ok", {verticalPosition: 'bottom'});
      }
    });
  }

  getPresetMessages(){
    let params = {
      FunctionName: environment.presetMessageLambdaName,
      Payload: JSON.stringify({
        operation: "get"
      })
    };
    this.telecomService.callLambda(params, "An error occurred getting message data").then((response: any) => {
      if(response.statusCode == 200){
        console.log('response: ', response);
        //get data from response and syncronize local copy
        this.cannedMessageData = JSON.parse(response.body);
        console.log(`data updated: ${JSON.stringify(this.cannedMessageData)}`);
        this.applyFilter(this.LOBFilter);
      }else{
        console.error(response); 
        this.snackbar.open(`Error: ${JSON.stringify(response.Error)}`, "Ok", {verticalPosition: 'bottom'});
      }
    });
  }

  openModal(){
    console.log("openModal works")
      const dialogRef = this.dialog.open(MessageModalComponent, {
      width: '40vw',
      height: '40vh',
      data: this.editMessage
    });
    // When modal closed...
    dialogRef.afterClosed().subscribe((result) => {
      if(result){
        this.editMessage = result;
      }
      console.log('The dialog was closed');
    });

  }

  handleButtonEvent(event){
    console.log(event);
    let newRow = event.item;

    if(event.button == "create"){
      this.creating = true;
      this.editing = true; 
      return
    }

    if(event.button == "confirm"){
      //add housekeeping data
      let groupChange = false;
      let now = new Date();
      let createdDate = this.timeService.getDateTimeString(now);
      newRow.message = this.editMessage;
      newRow.updatedDate = createdDate;
      newRow.updater = this.currentUser;
      if(this.creating){
        newRow.created = createdDate;
        newRow.creator = this.currentUser;
        newRow.id = this.newGUID();
      }
      //update real data with new row
      let oldRow = this.cannedMessageData.findIndex((messageData) => {return messageData.id == newRow.id});
      if(oldRow > -1){
        console.log("replacing old row...")
        if(this.cannedMessageData[oldRow].group !== newRow.group){
          console.log("group was changed...")
          groupChange = this.cannedMessageData[oldRow];
        }
        this.cannedMessageData[oldRow] = newRow;
      }
      else{
        this.cannedMessageData.push(newRow);
      }
      this.applyFilter(this.LOBFilter);
      //send new row to lambda/DDB
      //If the group changed, delete the old row, since the groupId is the primary key in the DDB
      console.log("groupChange = ", groupChange)
      if(groupChange){
        console.log("groupChanged = true")
        this.deleteRow(groupChange).then((result) => {
          this.sendRow(newRow);
        })
      }else{
        console.log("groupChanged = false")
        this.sendRow(newRow)
      }
      
      this.editMessage = "";
      this.editing = false; 
    }

    if(event.button == "edit"){
      this.editMessage = newRow.message;
      this.editing = true; 
    }

    if(event.button == "cancel"){
      this.editMessage = "";
      this.editing = false; 
    }

    if(event.button == "delete"){
      this.deleteRow(newRow);
    }

    this.creating = false
  }

  sendRow(row){
    let params = {
      FunctionName: environment.presetMessageLambdaName,
      Payload: JSON.stringify({
        operation: "put",
        data: [row]
      })
    };
    this.telecomService.callLambda(params, "An error occurred sending message data").then((response: any) => {
      if(response.statusCode == 200){
        console.log('put response: ', response);
        this.getPresetMessages();
      }else{
        console.error(response); 
        this.snackbar.open(`Error: ${JSON.stringify(response.Error)}`, "Ok", {verticalPosition: 'bottom'});
      }
    });
  }

  deleteRow(row){
    let params = {
      FunctionName: environment.presetMessageLambdaName,
      Payload: JSON.stringify({
        operation: "delete",
        data: row
      })
    };
    return this.telecomService.callLambda(params, "An error occurred deleting message data").then((response: any) => {
      if(response.statusCode == 200){
        console.log('delete response: ', response);
        this.getPresetMessages();
      }else{
        console.error(response); 
        this.snackbar.open(`Error: ${JSON.stringify(response.Error)}`, "Ok", {verticalPosition: 'bottom'});
      }
    });
  }

  applyFilter(searchString: string) {
    console.log("applying filter: ", searchString);

    //filter

    if (searchString != "") {
      this.filteredGroups = this.groups.filter((group) => {return group["LOB"] == searchString});

      this.filteredCannedMessageData = [];
      for (let x = 0; x < this.cannedMessageData.length; x++) {
        if (this.cannedMessageData[x].hasOwnProperty("group")) {
          let groupData = this.groups.find((groupRow) => {return groupRow.groupId == this.cannedMessageData[x].group})
          if (groupData.LOB == searchString) {
            this.filteredCannedMessageData.push(this.cannedMessageData[x]);
          }
        }
      }
    } else {
      this.filteredCannedMessageData = JSON.parse(JSON.stringify(this.cannedMessageData));
      this.filteredGroups = JSON.parse(JSON.stringify(this.groups));
    }
  }

  newGUID(){
    return Guid.create()['value'];
  }
}
